/**
 * Der Lautsprecher dieses Geräts: Antworten vorlesen — an oder stumm. (15.10.2026)
 *
 * Ein GERÄTEWERT (shared/einstellungen-felder.ts, „lautsprecher“): das Telefon in der Tasche ist
 * nicht der Rechner am Schreibtisch. Bis hierher lasen und schrieben ihn nur app.ts und seine vier
 * Knöpfe (Menü, Eingabe-Pille, Plus-Menü, Fußzeile). Jetzt hat auch die Einstellungsseite eine
 * Zeile dafür — und beide nehmen DIESE zwei Funktionen: eine Wahrheit, ein Schlüssel.
 * Wer schreibt, meldet es (`LAUTSPRECHER_EREIGNIS`); app.ts zieht seine Knöpfe nach.
 */
import { seitenOrt } from "../../shared/einstellung-aendern.js";

// Pre.147: Auto-Vorlesen-Toggle persistiert in localStorage. Vorher
// vergaß die App den State bei jedem Reload — Martin musste jedes Mal
// im Drawer neu anschalten.
const AUTOPLAY_STORAGE_KEY = "voice-v8.autoplay";

/** Das Ereignis am `window`, wenn jemand den Lautsprecher umstellt — mit `{ an }`. */
export const LAUTSPRECHER_EREIGNIS = "voice-v8:lautsprecher";

export function loadAutoPlay(): boolean {
  try {
    let v = localStorage.getItem(AUTOPLAY_STORAGE_KEY);
    // Migration (2026-06-27): die ALTE Logik schrieb beim ersten Laden
    // automatisch "0" (Default war AUS). Auto-Vorlesen ist jetzt Standard —
    // dieses legacy-"0" heben wir EINMALIG auf "1". Wer es nach der Migration
    // bewusst ausschaltet, behaelt sein "0" (Flag verhindert Re-Migration).
    if (v === "0" && localStorage.getItem("voice-v8.autoplay-migrated") !== "1") {
      v = "1";
      try {
        localStorage.setItem(AUTOPLAY_STORAGE_KEY, "1");
      } catch {
        /* ignore */
      }
    }
    try {
      localStorage.setItem("voice-v8.autoplay-migrated", "1");
    } catch {
      /* ignore */
    }
    // Default AN: ausser der User schaltet den Lautsprecher bewusst aus.
    return v === null ? true : v === "1";
  } catch {
    return true;
  }
}

export function saveAutoPlay(enabled: boolean): void {
  try {
    localStorage.setItem(AUTOPLAY_STORAGE_KEY, enabled ? "1" : "0");
  } catch {
    /* localStorage unavailable */
  }
  window.dispatchEvent(new CustomEvent(LAUTSPRECHER_EREIGNIS, { detail: { an: enabled } }));
}

/** Der Wert aus dem Ereignis — oder null, wenn es keines von uns ist. */
export function lautsprecherAus(ev: Event): boolean | null {
  const an = (ev as CustomEvent<{ an?: unknown } | null>).detail?.an;
  return typeof an === "boolean" ? an : null;
}

/**
 * So findet die Suche der Einstellungen den Schalter (settings/einst-suche.ts) — die Form der
 * Einträge in shared/einstellung-aendern.ts, nur ohne Zuruf: ein Gerätewert steht dort nie.
 */
export const LAUTSPRECHER_SUCHE = {
  kennung: "lautsprecher",
  titel: "Antworten vorlesen",
  woerter: [
    "antworten vorlesen", "lautsprecher", "vorlesen", "auto vorlesen", "automatisch vorlesen", "vorlesen an", "vorlesen aus",
    "stumm", "ton", "sprachausgabe", "laut", "leise",
  ],
  ort: seitenOrt("stimme"),
} as const;
